import React, { useState } from 'react';
import { Loading } from '@appkit4/react-components/loading';
import { Button } from '@appkit4/react-components/button';
import { Input } from '@appkit4/react-components/field';
import { CalendarPicker } from '@appkit4/react-components/datepicker';
import './SetupModal.scss';

interface CreateTimePeriodModalProps {
    isCreating: boolean;
    onSubmit: (data: { shortName: string; start: string; end: string }) => void;
}

const formatDate = (d: Date): string => {
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};

const CreateTimePeriodModal: React.FC<CreateTimePeriodModalProps> = ({
    isCreating,
    onSubmit,
}) => {
    const [periodName, setPeriodName] = useState('');
    const [periodDateRange, setPeriodDateRange] = useState<any>(null);

    const handleSubmit = () => {
        if (!periodName || !periodDateRange) return;

        let start: string;
        let end: string;

        if (Array.isArray(periodDateRange)) {
            if (periodDateRange.length !== 2) return;
            start = formatDate(new Date(periodDateRange[0]));
            end = formatDate(new Date(periodDateRange[1]));
        } else if (typeof periodDateRange === 'string') {
            const dates = periodDateRange.split(' - ');
            if (dates.length !== 2) return;
            start = dates[0];
            end = dates[1];
        } else {
            return;
        }

        onSubmit({ shortName: periodName, start, end });
    };

    return (
        <div className="setup-modal">
            <div className="setup-modal__backdrop" />
            <div
                role="dialog"
                aria-label="Create Your First Time Period"
                className="setup-modal__dialog"
            >
                <h2 className="setup-modal__title">
                    Create Your First Time Period
                </h2>
                <div className="setup-modal__body">
                    {isCreating ? (
                        <Loading loadingType="circular" indeterminate />
                    ) : (
                        <>
                            <p className="setup-modal__text">
                                Now create a time period to link your entity to.
                            </p>
                            <Input
                                title="Period Name"
                                value={periodName}
                                onChange={(value: string) =>
                                    setPeriodName(value)
                                }
                                required
                            />
                            <CalendarPicker
                                fieldTitle="Date Range"
                                format="YYYY-MM-DD"
                                selectRange
                                {...(periodDateRange !== null && {
                                    value: periodDateRange,
                                })}
                                onChange={(value: any) =>
                                    setPeriodDateRange(value)
                                }
                            />
                            <Button
                                onClick={handleSubmit}
                                kind="primary"
                                disabled={!periodName || !periodDateRange}
                            >
                                Create Time Period
                            </Button>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default CreateTimePeriodModal;
